import React, {PropTypes} from 'react';
import moment from 'moment';
import csvConvert from "../../classes/csvConvert";
import RaisedButton from 'material-ui/RaisedButton';

function mapRatingsToValue(value)
{
  switch(value)
  {
    case 'SEE': return 6;  //Significantly Exceeds Expectations
    case 'EE': return 4;   //Exceeds Expectations
    case 'ME-A': return 3; //Meets Expectations - All the time
    case 'ME-M': return 2; //Meets Expectations - Most of the time
    case 'ME-S': return 1; //Meets Expectations - Sometimes
    case 'NI': return 0;   //Needs Improvement
    case 'P': return 0;    //Poor
    default: return -1;
  }
}
function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
  switch (fieldValue) {
    case 'SEE':
      return 'darkgreen';
    case 'EE':
      return 'green1';
    case 'ME-A':
      return 'green2';
    case  'ME-M':
      return 'lightGreen';
    case 'ME-S':
      return 'lighterGreen';
    case  'NI':
      return 'amber';
    case 'P':
      return 'red';
    default:
      return '';
  }
}
let ratingType={
  "SEE":"SEE",
  "EE":"EE",
  "ME-A":"MEA",
  "ME-M":"MEM",
  "ME-S":"MES",
  "NI":"NI",
  "P":"P",
}

class QCapTable extends React.Component {

    constructor() {
      super();
      this.state = {csv: []}
      this.downloadCsv = this.downloadCsv.bind(this);
    }

  downloadCsv(dump) {
    let csvContent = new csvConvert();


    let tableData = csvContent.convertArrayOfQCapRatingsToCSV({data: dump});
    console.log(tableData);

    let blob = new Blob([tableData], {type: "text/csv;charset=utf-8;"});
    blob = window.webkitURL.createObjectURL(blob);
    let getCsv = new Promise((resolve, reject)=> {
      this.setState({csv: blob});
      resolve(true);
    });
    getCsv.then((response)=> {
      this.download.click();
    })
  }

    render() {
      console.log(this.props.data);
      let currentDate = new Date();
      currentDate.setDate(1);
      let previousMonth = currentDate;
      let formattedDate = moment(currentDate).format("YYYY-MM-DD");
      let keys = new Array();
     // previousMonth = moment(previousMonth).subtract(1,'month');
      for(var i=0;i<=12;i++)
      {
          previousMonth = moment(previousMonth).subtract(1,'month');
          let formattedDate = previousMonth.format("YYYY-MM-DD");
          keys.push(formattedDate);
      }
      //keys.reverse();

      var final = new Array();
      let j = 0;
      this.props.data.map((node)=>{
        final[j] = new Object();
        final[j].empId = this.props.data[j].empId;
        final[j].empName = this.props.data[j].empName;
        final[j].vertical = this.props.data[j].vertical;
        final[j].function = this.props.data[j].function;
        final[j].department = this.props.data[j].reportingTo;
        console.log(this.props.data[j].ratings);
        for(var key in this.props.data[j].ratings)
        {
          final[j][key] = this.props.data[j].ratings[key];
        }
        var scores = Object.keys(this.props.data[j].ratings).map((key) => {
          return [String(key), mapRatingsToValue(this.props.data[j].ratings[key])];
        });
        scores.sort(function(a,b){
          return new Date(a[0]) - new Date(b[0]);
        });
        let currentScore = new Array(); //last 12 months
        let windowScore = new Array(); //last 3 months
        let i;
        for(i=0; i<scores.length; i++)
        {
          if(scores[i][1]==-1) {
            console.log("Empty Value at position " + (i+1));
            continue;
          }
          currentScore.push(scores[i][1]);
          if(currentScore.length>12) {
            currentScore.shift();
          }
          windowScore.push(scores[i][1]);
          if(windowScore.length>3) {
            windowScore.shift();
          }
          if(currentScore.reduce((a,b) => a+b, 0) >= 36 && windowScore.every(val => val>=3)) {
            currentScore = [];
          }
        }
        final[j].Total = currentScore.reduce((a,b) => a+b, 0);
        j++;
      })

      return (
        <div>
          <a href={this.state.csv} download={"QCAP_Ratings.csv"} ref={(input) => {
            this.download = input;
          }}/>
          <RaisedButton
            label="Download"
            primary={true} onClick={()=>{
            this.downloadCsv(final);
          }}/>
          <BootstrapTable
            containerStyle={{borderBottomStyle: 'solid', borderColor: '#428BCA', borderWidth: '1px'}}
            headerStyle={{
              borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px'
              , borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
            }}

            data={final}>
            <TableHeaderColumn
              filter={{type: "TextFilter", placeHolder: "EmpId"}}
              isKey={true} dataField="empId">EmpId</TableHeaderColumn>
            <TableHeaderColumn
              dataSort={true}
              filter={{type: "TextFilter", placeHolder: "Name"}}
              dataFormat={(cell, row)=> {
                return <a onClick={()=> {
                }}>{cell}</a>
              }}
              dataField="empName">Name</TableHeaderColumn>
            <TableHeaderColumn
              dataSort={true}
              filter={{type: "TextFilter", placeHolder: "Vertical"}}
              dataFormat={(cell, row)=> {
                return <a onClick={()=> {
                }}>{cell}</a>
              }}
              dataField="vertical">Vertical</TableHeaderColumn>
            {/*<TableHeaderColumn*/}
              {/*dataSort={true}*/}
              {/*filter={{type: "TextFilter", placeHolder: "Function"}}*/}
              {/*dataFormat={(cell, row)=> {*/}
                {/*return <a onClick={()=> {*/}
                {/*}}>{cell}</a>*/}
              {/*}}*/}
              {/*dataField="function">Function</TableHeaderColumn>*/}
            <TableHeaderColumn
              dataSort={true}
              filter={{type: "TextFilter", placeHolder: "Department"}}
              dataFormat={(cell, row)=> {
                return <a onClick={()=> {
                }}>{cell}</a>
              }}
              dataField="department">Department</TableHeaderColumn>
            {keys.map((node)=>{
              return <TableHeaderColumn
                columnClassName={columnClassNameFormat}
                dataFormat={(cell,row)=>{
                  if(cell=='NA')
                    return null;
                  else
                    return <font color="white">{cell}</font>;
                }}
                filter={ {type: 'SelectFilter', options: ratingType, placeholder: 'Rating'} }
                dataField={node}>{moment(node).format("MMMM YY")}</TableHeaderColumn>
            })}
            <TableHeaderColumn
              filter={{type: "TextFilter", placeHolder: "Total"}}
              dataSort={true}
              dataField="Total">Cumulative Total</TableHeaderColumn>
          </BootstrapTable>
      </div>


    );
    }
}

QCapTable.propTypes = {};

export default QCapTable;





/** WEBPACK FOOTER **
 ** ./src/feature/qcap/QCapTable.js
 **/